module.exports = ['$scope', '$http', function($scope, $http) {
    $scope.redirectHome = function(){
        location.replace("/home/");
    }
}];